export default __webpack_public_path__ + "static/nurse-pointing-0db54a3b9e065a4162c143ff0433ed5f.png";